import { mapGetters } from 'vuex';
import mvtCollapse from '@/common/components/mvtcollapse/mvt-collapse.vue';
import mvtNearby from '@/common/components/mvtnearby/mvt-nearby.vue';
import mvtLazyload from '@/common/components/mvtlazyload/mvt-lazyload.vue';
import lazyCarouselCheckMixin from '@/common/mixins/lazycarouselcheck';

export default {
    name: 'propertyNearByZipcode',
    components: {
        mvtCollapse,
        mvtNearby,
        mvtLazyload,
    },
    props: ['disableCollapse', 'selectedSection', 'theme'],
    mixins: [lazyCarouselCheckMixin],
    mounted() {},
    computed: {
        ...mapGetters('glb', ['glb', 'getRecentlyViewed', 'getZipNewListings', 'getZipReducedListings', 'getZipOpenListings', 'getSplit']),
        ...mapGetters('dpp', ['dpp']),
    },
    methods: {
        completedPrice() {
            this.$refs.lazyloadPrice.ready();
        },
        completedOpen() {
            this.$refs.lazyloadOpen.ready();
        },
        completedNew() {
            this.$refs.lazyloadNew.ready();
        },
        getMSPLink(filter) {
            return this.glb.appUrl + this.dpp.geo.zipcodePath + filter + '/';
        },
    },
};
